export enum AIRevisionStatus {
  Ready = 'Ready',
  Scheduled = 'Scheduled',
  Completed = 'Completed',
}

type RevisionStatusDetails = Record<AIRevisionStatus, { displayName: string }>;

export const revisionStatusDetails: RevisionStatusDetails = {
  [AIRevisionStatus.Ready]: { displayName: 'AI Revision · Ready' },
  [AIRevisionStatus.Scheduled]: { displayName: 'AI Revision · AI Scheduled' },
  [AIRevisionStatus.Completed]: {
    displayName: 'AI Revision · Recently Completed',
  },
};
